document.addEventListener('DOMContentLoaded', function () {
  // Repositionne Instafeed juste après la barre d'annonce sur la homepage
  if (document.body.classList.contains('template-index')) {
    var announcement = document.querySelector('[id$="__announcement"]');
    var instafeed = document.querySelector('[id$="__1791915472457265af"]');
    if (announcement && instafeed) {
      announcement.after(instafeed);
    }
  }

  // Sticky ATC sur mobile (page produit)
  var stickyBar = document.getElementById('sticky-atc');
  var mainBtn = document.querySelector('.product-actions .btn-add-to-cart[type="submit"]');
  if (!stickyBar || !mainBtn) return;

  var observer = new IntersectionObserver(function (entries) {
    stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
  }, { threshold: 0 });
  observer.observe(mainBtn);

  var stickyAdded = false;

  function resetStickyBtn() {
    if (!stickyAdded) return;
    stickyAdded = false;
    stickyBtn.textContent = 'AJOUTER AU PANIER';
    stickyBtn.style.background = '';
    stickyBtn.disabled = false;
  }

  var stickyBtn = document.getElementById('sticky-atc-btn');

  stickyBtn.addEventListener('click', function () {
    if (stickyAdded) {
      window.location.href = '/cart';
      return;
    }

    var form = document.getElementById('product-form');
    if (!form) return;
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    stickyBtn.disabled = true;
    stickyBtn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        stickyBtn.textContent = 'AJOUTER AU PANIER';
        stickyBtn.disabled = false;
      } else {
        stickyAdded = true;
        stickyBtn.textContent = '✓ VOIR LE PANIER';
        stickyBtn.style.background = '#4a7c59';
        stickyBtn.disabled = false;
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count, #cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
      }
    })
    .catch(function () {
      stickyBtn.textContent = 'AJOUTER AU PANIER';
      stickyBtn.disabled = false;
    });
  });

  var observerWithReset = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) resetStickyBtn();
  }, { threshold: 0.5 });
  observerWithReset.observe(mainBtn);
});
